import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { SchoolDto, SchoolsService } from '../../../../core/api';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SchoolResolver implements Resolve<SchoolDto> {
  constructor(private schoolService: SchoolsService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<SchoolDto> {
    const id = route.paramMap.get('id')!;
    
    return this.schoolService.schoolControllerFindOne(Number(id));
  }
}
